module.exports = __webpack_public_path__ + "bdcdc89899814ac83b63efd2e2b20754.png";